import $http from '@/api/index'
import {
  getToken
} from '../../../util/auth'
const cookieUser = getToken()

//根据条件搜索创建人执行人
export function GetTemplateCreateExecUserSearchResult(para) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateCreateExecUserSearchResult',
    requestType: 2
  }
  let params = para;
  return $http(options, params);
}


//根据左侧的模板ID，获取搜索的创建人执行人，模板可以是结果集模板也可以是搜索模板。
export function GetTemplateCreateExecUserSearchByTemplateID(templateId, userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateCreateExecUserSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId,
    userId
  }
  return $http(options, params);
}
// 模板搜索创建人执行人，返回常用排序后的结果集（这里比较特殊，只返回已经在搜索结果记录中的数据 PUB_TEMPLATE_PICKLOG）
export function GetTemplateCreateExecUserSearchByCount(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateCreateExecUserSearchByCount',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}
// 通过机构、组织、服务台ID 获取其下人员
export function GetUserResultByListCreateExecUserID(listID, userId) {
  let options = {
    method: 'POST',
    url: 'basedata/GetUserResultByListCreateExecUserID',
    requestType: 2
  }
  let params = {
    listID,
    userId
  }
  return $http(options, params);
}
//通过ID集合获取任务创建、执行对象
export function GetTemplateCreateExecUserSearchByListID(listId, userId) {
  let options = {
    method: 'POST',
    url: 'basedata/GetTemplateCreateExecUserSearchByListID',
    requestType: 2
  }
  let params = {
    listId,
    userId
  }
  return $http(options, params);
}
// 通过关键字搜索任务创建、执行对象
export function GetTemplateCreateExecUserByKeyword(keyword, userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateCreateExecUserByKeyword',
    requestType: 2
  }
  let params = {
    keyword,
    userId
  }
  return $http(options, params);
}

//  获取当前人员具有权限的服务台
export function GetAllServerCenterManageByUserId(userId) {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllServerCenterManageByUserId',
    requestType: 2
  }
  let params = {
    userId
  }
  return $http(options, params);
}


//  根据条件搜索运维对象实例
export function GetTemplateDeviceObjectSearchResult(para, pageIndex, pageSize) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateDeviceObjectSearchResult',
    requestType: 2
  }
  let params = {
    para: para,
    pageIndex: pageIndex,
    pageSize: pageSize
  }
  return $http(options, params);
}
//  根据左侧的模板ID，获取搜索的运维对象实例，模板可以是结果集模板也可以是搜索模板。
export function GetTemplateDeviceObjectSearchByTemplateID(templateId, userId, pageIndex, pageSize) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateDeviceObjectSearchByTemplateID',
    requestType: 2
  }
  let params = {
    templateId,
    userId,
    pageIndex,
    pageSize
  }
  return $http(options, params);
}
//  根据选中的一级类型分类，获取当前实例具有的二级类型
export function GetObjectTypeByFirstObjectType(type) {
  let options = {
    method: 'GET',
    url: 'basedata/GetObjectTypeByFirstObjectType',
    requestType: 2
  }
  let params = {
    type
  }
  return $http(options, params);
}

//  通过关键字搜索运维对象实例
export function GetTemplateDeviceObjectByKeyword(keyword, userId, pageIndex, pageSize, devtype, secondTypeCode) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateDeviceObjectByKeyword',
    requestType: 2
  }
  let params = {
    keyword,
    userId,
    pageIndex,
    pageSize,
    devtype,
    secondTypeCode
  }
  return $http(options, params);
}

//  获取所有已经搜索过的运维对象实例
export function GetTemplateDeviceObjectByCount(userId, pageIndex, pageSize, Type) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateDeviceObjectByCount',
    requestType: 2
  }
  let params = {
    userId,
    pageIndex,
    pageSize,
    Type
  }
  return $http(options, params);
}

//  通过ID集合获取运维对象实例
export function GetTemplateDeviceObjectByListID(jobj, pageIndex, pageSize) {
  let options = {
    method: 'GET',
    url: 'basedata/GetTemplateDeviceObjectByListID',
    requestType: 2
  }
  let params = {
    jobj,
    pageIndex,
    pageSize
  }
  return $http(options, params);
}
// 获取所有厂商
export function GetAllBrandSysCompanyEx() {
  let options = {
    method: 'GET',
    url: 'basedata/GetAllBrandSysCompanyEx',
    requestType: 2
  }
  let params = {

  }
  return $http(options, params);
}
//根据用户id获取对应的用户
export function GetAuditContactUserInfoByUserid(userId) {
  let options = {
    method: 'GET',
    url: 'user/GetAuditContactUserInfoByUserid',
    requestType: 2
  }
  let params = {
    userid: userId
  };
  return $http(options, params);
}
//新增修改联系人（临时人员）
export function AddOrUpdateContactInfoAndReturnContactID(contactInfo) {
  let options = {
    method: 'GET',
    url: 'basedata/AddOrUpdateContactInfoAndReturnContactID',
    requestType: 2
  }
  let params = {
    contactInfo
  };
  return $http(options, params);
}

//检测联系人号码是否已经存在库中
export function IsContactPhoneExist(phone, contactId) {
  let options = {
    method: 'GET',
    url: 'basedata/IsContactPhoneExist',
    requestType: 2
  }
  let params = {
    phone,
    contactId
  };
  return $http(options, params);
}
//删除联系人
export function DeleteContactInfoById(id) {
  let options = {
    method: 'GET',
    url: 'basedata/DeleteContactInfoById',
    requestType: 2
  }
  let params = {
    id
  };
  return $http(options, params);
}

//获取新版本运维对象二级树结构
export function GetNewObjectTypeTree() {
  let options = {
    method: 'GET',
    url: 'basedata/GetNewObjectTypeTree',
    requestType: 2
  }
  let params = {};
  return $http(options, params);
}
//新版本运维对象 ，新增一级
export function AddOrUpdateFirstLevel(model) {
  let options = {
    method: 'GET',
    url: 'basedata/AddOrUpdateFirstLevel',
    requestType: 2
  }
  let params = {
    model
  };
  return $http(options, params);
}

//新版本运维对象 ，新增二级
export function AddOrUpdateSecondLevel(model) {
  let options = {
    method: 'GET',
    url: 'basedata/AddOrUpdateSecondLevel',
    requestType: 2
  }
  let params = {
    model
  };
  return $http(options, params);
}

//新版本运维对象 ，删除一级
export function DelFirstLevel(id) {
  let options = {
    method: 'GET',
    url: 'basedata/DelFirstLevel',
    requestType: 2
  }
  let params = {
    id
  };
  return $http(options, params);
}

//新版本运维对象 ，删除二级
export function DelSecondLevel(id) {
  let options = {
    method: 'GET',
    url: 'basedata/DelSecondLevel',
    requestType: 2
  }
  let params = {
    id
  };
  return $http(options, params);
}